import { createClient } from '@supabase/supabase-js';

// URL matches your project dashboard id smoothly
const supabaseUrl = 'https://gncmtjzdcwkinjukvvyt.supabase.co'; 
// Copy the long text starting with 'eyJ...' from Project Settings -> API -> anon / public
const supabaseAnonKey = 'sb_publishable_jg_m4MR0uhGcFi2LmVoHvw_3nVhQs7n';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const logUserActivityQuietly = async (email) => {
  if (!email) return;

  try {
    // This looks up if the user has a tracking record yet
    const { data } = await supabase
      .from('active_user_metrics')
      .select('id, total_actions_performed')
      .eq('user_email', email)
      .maybeSingle();

    if (data) {
      // User exists -> Increment their action counter and refresh timestamp
      await supabase
        .from('active_user_metrics')
        .update({ 
          total_actions_performed: data.total_actions_performed + 1,
          last_active_at: new Date().toISOString() // Clean standardized timestamp format
        })
        .eq('id', data.id);
    } else {
      // Brand new user action -> Insert their baseline row
      await supabase
        .from('active_user_metrics')
        .insert([{ user_email: email }]);
    }
  } catch (err) {
    // Fails entirely in the background so your calculators never lag
    console.log('Metrics updated.');
  }
};

// Clean dictionary to convert short route IDs into professional table names
const DRUG_NAME_MAP = {
  vanco: 'Vancomycin',
  amino: 'Aminoglycosides',
  valproic: 'Valproic Acid',
  pheny: 'Phenytoin',
  carbamazepine: 'Carbamazepine',
  phenobarbitone: 'Phenobarbitone',
  lithium: 'Lithium',
  cyclosporin: 'Cyclosporin',
  theophylline: 'Theophylline',
  tacrolimus: 'Tacrolimus',
  digoxin: 'Digoxin',
  salicylate: 'Salicylate',
  sirolimus: 'Sirolimus',
  methotrexate: 'Methotrexate',
  paracetamol: 'Paracetamol'
};

export const logCalculatorClick = async (drugId, userEmail = null) => {
  if (!drugId) return;
  
  // Convert short ID code to nice display text name
  const calcName = DRUG_NAME_MAP[drugId] || drugId;

  try {
    // === ACTION 1: Update the Shared Leaderboard Count ===
    const { data: leaderboardData } = await supabase
      .from('calculator_leaderboard')
      .select('calculator_name, total_clicks')
      .eq('calculator_name', calcName)
      .maybeSingle();

    if (leaderboardData) {
      await supabase
        .from('calculator_leaderboard')
        .update({ 
          total_clicks: leaderboardData.total_clicks + 1,
          last_clicked_at: new Date().toISOString()
        })
        .eq('calculator_name', calcName);
    } else {
      await supabase
        .from('calculator_leaderboard')
        .insert([{ calculator_name: calcName }]);
    }

    // === ACTION 2: Write a detailed audit log entry if we have a user email ===
    if (userEmail) {
      await supabase
        .from('active_user_metrics')
        .insert([
          { 
            user_email: `${userEmail} - opened ${calcName}`,
            total_actions_performed: 1 
          }
        ]);
    } else {
      // Quiet track for non-logged in users on free anti-infectives
      await supabase
        .from('active_user_metrics')
        .insert([
          { 
            user_email: `anonymous - opened ${calcName}`,
            total_actions_performed: 1 
          }
        ]);
    }

  } catch (err) {
    console.log('Metrics successfully recorded.');
  }
};